// Games the server pushes as slippi_game_recorded (a player's folder recorded
// one) go from ServerMessageController to whichever friendlies board is open.

const listeners = new Set();

export function subscribeToRecordedGames(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function publishRecordedGame(message) {
	listeners.forEach(listener => listener(message));
}
